require('../../modules/es7.object.to-array');
module.exports = require('../../modules/$').core.Object.entries;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/core-js/library/fn/object/entries.js
 ** module id = 812
 ** module chunks = 0
 **/